import React, { useState } from "react";
import { ShieldCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function ForcePasswordChange() {
  const { user, refreshMe, logout } = useAuth();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) return toast.error("Password must be at least 6 characters");
    if (pw !== pw2) return toast.error("Passwords don't match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { new_password: pw });
      toast.success("Password updated — welcome to Connect!");
      await refreshMe();
    } catch (err) { toast.error(apiError(err)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center p-4" data-testid="force-password-change">
      <div className="w-full max-w-md bg-white rounded-2xl border-2 border-border shadow-lg p-7">
        <div className="w-14 h-14 rounded-2xl bg-forest-900 flex items-center justify-center mb-4">
          <ShieldCheck size={28} strokeWidth={2.5} className="text-white" />
        </div>
        <h1 className="font-head text-2xl font-bold text-forest-900">Set your password</h1>
        <p className="text-forest-700 mt-1">Welcome{user?.name ? `, ${user.name}` : ""}! You were added as a town admin with a temporary password. Please choose your own password to continue.</p>
        <form onSubmit={submit} className="mt-5 space-y-3">
          <input data-testid="new-password" type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="New password" className="w-full min-h-[52px] p-3 rounded-xl border-2 border-border focus:border-terracotta outline-none bg-cream" />
          <input data-testid="confirm-password" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Confirm new password" className="w-full min-h-[52px] p-3 rounded-xl border-2 border-border focus:border-terracotta outline-none bg-cream" />
          <button type="submit" disabled={busy} data-testid="save-password-btn" className="w-full min-h-[52px] rounded-full bg-terracotta text-white font-bold hover:bg-terracotta-dark disabled:opacity-60 flex items-center justify-center gap-2">
            {busy ? <><Loader2 size={20} className="animate-spin" /> Saving…</> : "Save & continue"}
          </button>
        </form>
        <button onClick={logout} data-testid="force-logout-btn" className="mt-4 text-forest-500 font-semibold text-sm hover:text-forest-700">Log out instead</button>
      </div>
    </div>
  );
}
